start_new_ad = function () {
    if (window.is_authenticated) {
        location.href = '/host/anunciar-quarto';
    } else {
        EventBus.$emit('open-modal', 'register-modal', {'next_step': 'property_form'});
    }
}
